/**
 * Тыблица для оценочного листа.
 */
import React from "react";
import Button from '@material-ui/core/Button'
import {withStyles} from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";
import TextareaAutosize from 'react-textarea-autosize'

const styles = {
  tableBordered: {
    width: '100%',

    '& tr th': {
      padding: '7px 12px',
      border: '1px solid #ddd',
      backgroundColor: '#eee'
    },

    '& tr td': {
      border: '1px solid #ddd',
      padding: '0 12px'
    },

    '& tr:last-child td': {
      border: '1px solid #ddd',
      padding: '7px 12px'
    },

    '& tr td input': {
      width: '100%',
      padding: '7px 0',
      border: 'none',
      backgroundColor: '#fafafa'
    },
    '& tr td textarea': {
      width: '100%',
      padding: '7px 0',
      marginTop: '5px',
      border: 'none',
      backgroundColor: '#fafafa'
    }
  },
  deleteIcon: {
    fill: 'red',
    fontSize: '12px'
  },
  button: {
    padding: '3px',
    minWidth: '0',
    minHeight: '0',
    backgroundColor: '#fff',
    '&:hover': {
      backgroundColor: '#fff'
    },
    cursor: 'pointer'
  },
  buttonAdd: {
    marginLeft: '15px',
    padding: '7px 12px',
    minWidth: '0',
    minHeight: '0',
    backgroundColor: '#fff',
    '&:hover': {
      backgroundColor: '#fff'
    },
    cursor: 'pointer'
  }
}

const AnswersTable = ({classes, data, totalBalls, onCellChange, onTotalChange, onRowRemove, onRowAdd, showAdditionText}) => {
  return (
    <section>
      <table className={classes.tableBordered}>
        <thead>
        <tr>
          <th style={{textAlign: 'left'}}>№ задания</th>
          <th style={{textAlign: 'left'}}>Маркировочная позиция</th>
          <th style={{textAlign: 'left', width: '50px'}}>Макс. балл</th>
          <th style={{textAlign: 'left'}}>&nbsp;</th>
          <th style={{textAlign: 'left'}}>&nbsp;</th>
          {showAdditionText && (
            <th>&nbsp;</th>
          )}
          {showAdditionText && (
            <th>&nbsp;</th>
          )}
          {showAdditionText && (
            <th>&nbsp;</th>
          )}
          {showAdditionText && (
            <th>&nbsp;</th>
          )}
          <th>&nbsp;</th>
        </tr>
        </thead>
        <tbody>
        {data.map((row, index) => {
          return (
            <tr>
              <td>
                <TextareaAutosize onChange={(event) => onCellChange(index, 'number', event.target.value)}>
                  {row.number}
                </TextareaAutosize>
              </td>
              <td>
                <TextareaAutosize onChange={(event) => onCellChange(index, 'mark', event.target.value)}>
                  {row.mark}
                </TextareaAutosize>
              </td>
              <td><input type="number" min="0" step="0.1" value={row.maxBalls} onChange={(event) => onCellChange(index, 'maxBalls', event.target.value.replace(',', '.'))} /></td>
              <td>
                <TextareaAutosize onChange={(event) => onCellChange(index, 'correctValues', event.target.value)}>
                  {row.correctValues}
                </TextareaAutosize>
              </td>
              <td>
                <TextareaAutosize onChange={(event) => onCellChange(index, 'solution', event.target.value)}>
                  {row.solution}
                </TextareaAutosize>
              </td>
              {showAdditionText && (
                <td>
                  <TextareaAutosize onChange={(event) => onCellChange(index, 'additionText1', event.target.value)}>
                    {row.additionText1}
                  </TextareaAutosize>
                </td>
              )}
              {showAdditionText && (
                <td>
                  <TextareaAutosize onChange={(event) => onCellChange(index, 'additionText2', event.target.value)}>
                    {row.additionText2}
                  </TextareaAutosize>
                </td>
              )}
              {showAdditionText && (
                <td>
                  <TextareaAutosize onChange={(event) => onCellChange(index, 'additionText3', event.target.value)}>
                    {row.additionText3}
                  </TextareaAutosize>
                </td>
              )}
              {showAdditionText && (
                  <td>
                    <TextareaAutosize onChange={(event) => onCellChange(index, 'additionText4', event.target.value)}>
                      {row.additionText4}
                    </TextareaAutosize>
                  </td>
              )}
              <td style={{textAlign: 'center'}}>
                <Button className={classes.button} variant="contained" onClick={() => onRowRemove(index)}>
                  <CloseIcon className={classes.deleteIcon} />
                </Button>
              </td>
            </tr>
          )
        })}
        <tr>
          <td colSpan={2}><b>Итого по подвопросу</b></td>
          <td>
            <input type="number" value={totalBalls} onChange={(event) => onTotalChange(event.target.value.replace(',', '.'))} />
          </td>
          <td colSpan={showAdditionText ? 7 : 3}>&nbsp;</td>
        </tr>
        </tbody>
      </table>
      <p>
        <Button className={classes.buttonAdd} variant="contained" onClick={() => onRowAdd()}>
          Добавить
        </Button>
      </p>
    </section>
  )
}

export default withStyles(styles)(AnswersTable)